import type { AccountUserRole } from "./AccountSeatOverview";

export type AcceptInviteNextAction =
  | "OPEN_WEB_DASHBOARD"
  | "USE_ANDROID_APP"

export function isAcceptInviteNextAction(value: string): value is AcceptInviteNextAction {
  return (
    value ===  "OPEN_WEB_DASHBOARD" ||
    value ===  "USE_ANDROID_APP"
  );
}

export interface ResendAccountInvitationCommand {
  invitationId: string;
}

export interface ResendAccountInvitationResult {
  invitationId: string;
  email: string;
  role: AccountUserRole;
  personId: string | null;
  expiresAt: Date;
}

export interface RevokeInvitationCommand {
    invitationId: string;
}

export type InvitePreview = {
  email: string;
  role: string;
  expiresAt: Date;
  requiresPerson: boolean;
};

export type AcceptInvitePersonCommand = {
  displayName: string;
  preferredName?: string;
  mobilePhoneE164?: string;
  canAppearInPhoto: boolean;
};

export type AcceptInviteCommand = {
  token: string;
  password: string;
  person: AcceptInvitePersonCommand | null;
  acceptedUserTermsVersion: string;
  acceptedPrivacyVersion: string;
};

export type AcceptInviteResult = {
  accountId: string;
  userId: string;
  personId: string;
  role: AccountUserRole;
  nextAction: AcceptInviteNextAction;

  accessToken?: string;
  accessExpiresAt?: number;
};

export type AcceptInvitationOutcome =
  | {
      type: "web-dashboard";
      accountId: string;
      userId: string;
      personId: string;
      role: AccountUserRole;
      dashboardPath: "/dashboard";
    }
  | {
      type: "android-app";
      accountId: string;
      userId: string;
      personId: string;
      role: AccountUserRole;
    };
